import React, { useState } from "react";
import { motion } from "motion/react";
import ToolbarLogoSm from "@/assets/icons/ToolbarLogoSm.svg";
import Logout from "@/assets/icons/Logout.svg";
import QuestionMark from "@/assets/icons/QuestionMark.svg";
import MCP from "@/assets/icons/MCP.svg";
import useUserData from "@/hooks/useUserData";
import { profilePictures } from "@/lib/data";
import { deleteCookie } from "@/lib/cookies";
import { useWorkspaceStore } from "@/hooks/useWorkspace";
import { useNavigate } from "react-router-dom";
import { syncLogoutToExtension } from "@/utils/extensionSync";
import MCPModal from "./MCPModal";

const buttons = [
  {
    icon: ToolbarLogoSm,
    action: "install",
    href: "https://chromewebstore.google.com/detail/toolbar-bug-reports-with/jjikojjfkjcbjklhldnjdnelfmjjmifg",
    label: "Install Toolbar extension",
  },
  {
    icon: MCP,
    action: "mcp",
    label: "Install Toolbar MCP",
  },
  {
    icon: QuestionMark,
    action: "docs",
    href: "https://docs.usetool.bar/",
    label: "Docs",
  },
];

const UserDropdown = ({
  setIsOpen,
}: {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { user } = useUserData();
  const { setCurrentWorkspace } = useWorkspaceStore();
  const navigate = useNavigate();
  const [isMCPModalOpen, setIsMCPModalOpen] = useState(false);

  const handleButtonClick = (action: string) => {
    if (action === "mcp") {
      setIsMCPModalOpen(true);
    }
  };
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="dropdown-shadow absolute font-medium text-[14px] leading-[20px] bottom-[41px] z-[1000] bg-gray-300 left-0 w-[280px] rounded-[16px] max-h-[220px]"
    >
      <div className="flex text-white h-[48px] p-1 w-full border-b-[4px] border-white/[0.08]">
        <div className="flex w-full px-3 transition-all rounded-[12px] ring-0 outline-0 items-center justify-start gap-1.5">
          {user?.profilePicture ? (
            <img
              src={profilePictures[user.profilePicture]}
              className="cursor-pointer border-[1px] w-4 h-4 border-white/[0.32] rounded-[50%]"
            />
          ) : (
            <div className="border-[1px] w-[21px] h-[21px] border-white/[0.55] rounded-[50%]" />
          )}
          <p>{user.username}</p>
        </div>
        {/* <p className="text-gray-800">{user.email}</p> */}
      </div>
      <ul className="p-1 flex flex-col gap-1">
        {buttons.map((button, i) => {
          if (button?.href) {
            return (
              <a
                className={`hover:bg-white/[0.04] transition-all h-[36px] gap-2 px-3 rounded-[12px] flex items-center`}
                key={i}
                href={button.href}
                target="_blank"
              >
                <img src={button.icon} />
                {button.label}
              </a>
            );
          } else {
            return (
              <button
                className={`hover:bg-white/[0.04] transition-all h-[36px] gap-2 px-3 rounded-[12px] flex items-center`}
                key={i}
                onClick={() => handleButtonClick(button.action)}
              >
                <img src={button.icon} />
                {button.label}
              </button>
            );
          }
        })}
      </ul>
      <div className="text-[#E93D82] h-[48px] p-1 text-[14px] leading-[20px] w-full rounded-none border-t-[4px] border-white/[0.08]">
        <button
          className="ring-0 px-3 gap-1.5 transition-all hover:bg-red-alpha/[0.16] rounded-[12px] w-full h-[36px] outline-0 flex items-center justify-start"
          onClick={() => {
            syncLogoutToExtension();
            deleteCookie("token");
            setCurrentWorkspace(null);
            navigate("/auth");
          }}
        >
          <img src={Logout} /> Log out
        </button>
      </div>
      <MCPModal
        isOpen={isMCPModalOpen}
        onClose={() => setIsMCPModalOpen(false)}
      />
    </motion.div>
  );
};

export default UserDropdown;
